// extracted by mini-css-extract-plugin
var _1 = "MonthSpinInput-moduleMonthSpinInput__BnQUu MonthYearSpinInput-moduleMonthYearSpinInput__ToJal NavArrows-moduleNavArrows__ZbT73";
export { _1 as "MonthSpinInput" }
